import { faCloudDownload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

export default function DownloadCaLink({ href, className }) {
  return (
    <div className={className}>
      <a className="btn btn-primary mt-1" href={href} rel="noopener noreferrer" target="_blank">
        <FontAwesomeIcon className="me-1" icon={faCloudDownload}/> Download CA
      </a>
    </div>
  );
}

DownloadCaLink.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string.isRequired
};
